
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Vénissieux dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Vénissieux certifiée Google Partner, accompagne les entreprises vénissianes dans l'amélioration de leur visibilité en ligne et la conquête de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Vénissieux dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Vénissieux certifiée Google Partner, accompagne les entreprises vénissianes dans l'amélioration de leur visibilité en ligne et la conquête de nouveaux clients.",
        },
      ],
    };
  },
};
